import React, { useEffect, useState } from "react"
import "bootstrap/dist/css/bootstrap.css"
import "./App.scss"
import { Route, Routes } from "react-router-dom"
import { Page404 } from "./views/404/404"
import "./languages/index"
import Login from "./views/Login"
import AuthContext from "./context/auth/AuthContext"
import { AccessAPI } from "./api/common/AccessAPI"
import { ComixtimeContainer } from "./components/Layout/ComixtimeContainer/ComixtimeContainer"
import HomePage from "./views/HomePage"
import { admRoutes, dexRoutes, pubRoutes } from "./routes"
import { Spin } from "antd"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { useLocation } from "react-router"
import Consents from "./views/Consents"
import { extendAuthContext } from "./types/user/AuthContextData"
import { ExtendedAuthContextData } from "./context/auth/useAuthContext"

const loadingFn = () => (
  <div className="animated fadeIn pt-5 justify-content-center align-content-center">
    <Spin spinning={true} />
  </div>
)

export function App() {
  const queryClient = new QueryClient()
  const [loading, setLoading] = useState<boolean>(true)
  const [isLogged, setIsLogged] = useState<boolean>(false)
  const [firstAccess, setFirstAccess] = useState<boolean>(false)
  const [consents, setConsents] = useState<boolean>(false)

  const [user, setUser] = useState<ExtendedAuthContextData | undefined>(undefined)

  const location = useLocation()

  useEffect(() => {
    document.title = "Platform"
    setFirstAccess(false)
    setConsents(false)
    if (location.pathname == "/firstaccess") setFirstAccess(true)
    else if (location.pathname == "/consents") setConsents(true)
    setLoading(true)
    AccessAPI.verifyToken()
      .then((response) => {
        setUser(extendAuthContext(response.data))
        setIsLogged(true)
      })
      .catch(() => {
        setIsLogged(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  let page = <>{loadingFn()}</>

  if (!loading) {
    if (!isLogged) {
      if (consents) page = <Consents checkbox={false} />
      else page = <Login firstAccess={firstAccess} />
    } else {
      if (user?.isPublisher() && user.pub_consents_compiled != true) {
        page = <Consents checkbox={true} />
      } else {
        page = (
          <QueryClientProvider client={queryClient}>
            <AuthContext.Provider value={user}>
              <ComixtimeContainer>
                <Routes>
                  <Route path={"/"} element={<HomePage />} />
                  {user?.isPublisher() &&
                    pubRoutes.map((route, i) => {
                      return route.component ? <Route key={i} path={route.path} element={<route.component />} /> : null
                    })}
                  {dexRoutes.map((route, i) => {
                    return route.component ? <Route key={i} path={route.path} element={<route.component />} /> : null
                  })}
                  {user?.hasChosenAccess() &&
                    admRoutes.map((route, i) => {
                      return route.component ? <Route key={i} path={route.path} element={<route.component />} /> : null
                    })}
                  <Route path={"*"} element={<Page404 />} />
                </Routes>
              </ComixtimeContainer>
            </AuthContext.Provider>
          </QueryClientProvider>
        )
      }
    }
  }

  return <React.Suspense fallback={loadingFn()}>{page}</React.Suspense>
}
